export default __webpack_public_path__ + "static/media/black-draw-measure-icon.edd8f297.svg";